import Api from '@api/xiu_yan/serviceAccount'
import { ACCOUNT_MANAGE_PATH } from '@constant'
import BaseStore from '@store/table'
import { isExperienceStore, isStoreAccount } from '@util'
import { message, Modal } from 'hljd'
import { action, observable } from 'mobx'
import { hashHistory } from 'react-router'

class Store extends BaseStore {
  /*控制列表显示*/
  @observable isAccountShow = false

  @action
  setStoreData = (type, value) => {
    this[type] = value
  }

  @action
  hiddenValidateModal = () => {
    this.isAccountShow = !this.isAccountShow
  }
  @action
  cancelValidate = () => {
    // 加盟店特殊处理
    if (isStoreAccount()) {
      hashHistory.push(ACCOUNT_MANAGE_PATH)
      return
    }

    if (window.history.length == 1) {
      window.location.href = '#/localMerchant/home'
    } else {
      window.history.go(-1)
    }
  }
  @action
  resetStatus = () => {
    //每次进入路由时，均显示弹窗，验证后才显示列表
    this.isAccountShow = false
  }

  validateToList = async ({ msgCode, mobile }) => {
    const { success } = await Api.checkMsgCode({
      sms: msgCode,
      phone: mobile
    })

    if (success) {
      this.isAccountShow = true
    }
  }

  id
  $listApi = Api.getListApi
  //修改模态框
  @observable nick = ''
  @observable isModifyShow = false
  @action
  goModify = (id, nick) => () => {
    this.id = id
    this.nick = nick
    this.modifyModal()
  }
  @action
  modifyModal = () => {
    this.isModifyShow = !this.isModifyShow
  }
  @action
  changeField = e => {
    this.nick = e.target.value
  }
  @action
  initRemarksModal = () => {
    this.nick = ''
  }
  @action
  changeStatus = (id, status, roles) => checked => {
    this.id = id
    let params = {
      id,
      status: checked ? '1' : '2'
    }
    this.modifyRequest(params)
  }
  modifyOk = async () => {
    if (!this.nick) {
      return message.warning('请填写备注内容~')
    }
    if (this.nick.length > 12) {
      return message.warning('最多填写12个字~')
    }
    let params = {
      id: this.id,
      nick: this.nick
    }
    this.modifyRequest(params, this.modifyModal)
  }
  modifyRequest = async (params, cb) => {
    const {
      status: { msg, RetCode },
      extend
    } = await Api.modifyApi(params)
    if (RetCode == 0) {
      message.success('修改成功！')
      if (cb) {
        cb()
      }
      this.$getList(1)
    } else if (RetCode === -2) {
      Modal.warning({
        title: '账号数量超出限制',
        content: msg,
        className: 'beyond-modal'
      })
    } else if (RetCode === 401) {
      let merchant = ''
      if (extend.last_merchants.length > 3) {
        merchant = extend.last_merchants
          .slice(0, 3)
          .map(item => `${item.name}丨${item.city}`)
          .join('、')
        merchant = merchant + `等${extend.last_merchants.length}个商家`
      } else {
        merchant = extend.last_merchants
          .map(item => `${item.name}丨${item.city}`)
          .join('、')
      }
      Modal.warning({
        title: '取消在线失败',
        content: `该账号是${merchant}的最后一个在线客服，有其他客服在线时才能取消在线状态。`,
        className: 'beyond-modal'
      })
    } else {
      return message.warning(msg)
    }
  }
  confirmDelete = (id, nick) => () => {
    if (isExperienceStore()) {
      return message.warn('请到运营后台-洗客派单员工处删除')
    }

    Modal.confirm({
      title: '确认',
      content: `确认删除 ${nick}`,
      onOk: () => {
        this.deleteRequest(id)
      }
    })
  }
  deleteRequest = async id => {
    const { success } = await Api.deleteApi(id)
    if (success) {
      message.warning('删除成功~')
      this.$getList(1)
    }
  }
}

export default new Store()
